import { Component, ViewChild } from '@angular/core';
import {
  FilterableSettings,
  DataBindingDirective,
} from '@progress/kendo-angular-grid';
import { SVGIcon, filePdfIcon, fileExcelIcon } from '@progress/kendo-svg-icons';

import { PaymentService } from '../../../core/services/payment.service';
import { AppConfigData } from '../../../core/config/appConfigData';
import { Store, select } from '@ngrx/store';
import { Router } from '@angular/router';

import Swal from 'sweetalert2';
//import { CurrencyPipe } from '@angular/common';

import { walletHistroeyResponse } from '../../../store/Wallet/wallet-selector';
import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
  UntypedFormBuilder,
  UntypedFormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { DecimalPipe } from '@angular/common';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Validations } from '../../../shared/constants/validations';

import { Observable } from 'rxjs';
import {
  ModeOfPaymentsAutoPay,
  SweetAlertIcon,
} from '../../../shared/constants/enum';
import { SharedService } from '../../../shared/shared.service';
import orders from 'razorpay/dist/types/orders';
import { escape } from 'querystring';
import { LoaderService } from '../../../core/services/loader.service';
import { RpAlertsComponent } from '../../../shared/components/rp-alerts/rp-alerts.component';
import { WalletService } from '../../../core/services/wallet.services';
import { NotificationService } from '../../../shared/notification.service';
declare var Razorpay: any;
@Component({
  selector: 'app-rp-wallet',
  templateUrl: './rp-wallet.component.html',
  styleUrl: './rp-wallet.component.scss',
  "standalone": false,
  providers: [DecimalPipe],
})
export class RpWalletComponent {
  modelRef_1!: BsModalRef;
  ModeOfPaymentsAutoPay = ModeOfPaymentsAutoPay;
  ServiceError = Validations.ServiceError;
  amountTempArray = [{ amount: 500 }, { amount: 1000 }, { amount: 2000 }];
  amountValues: any[] = [];
  walletForm!: UntypedFormGroup;
  autopayForm!: UntypedFormGroup;
  public filterMode: FilterableSettings = 'row';
  public filePdfIcon: SVGIcon = filePdfIcon;
  public fileExcelIcon: SVGIcon = fileExcelIcon;
  max_amount: any;
  isLowBalanceAlertNotification: boolean = false;
  paymentlaertModal!: BsModalRef;
  min_amount: any;
  paymentDetails: any;
  @ViewChild(DataBindingDirective) dataBinding!: DataBindingDirective;
  submitted: boolean = false;
  autosubmitted: boolean = false;
  selectValue!: string[];
  amount: any;

  currentUserData: any;
  projectId: any;
  userId: any;
  userPhone: any;
  useremail: any;
  max_amount_error: boolean = false;
  userName: any;
  walletHistoryList: any;
  isAutoPayForRecharge: boolean = false;
  flatNos: any;
  undefinde: any;
  regex = /^[0-9]*$/;
  // regexp = /^[0-9]*(\.[0-9]{0,2})?$/;
  regexp = /^(?!0\d)\d+(\.\d{1,2})?$/;
  breadCrumbItems: Array<{}> | undefined;
  constructor(
    private decimalPipe: DecimalPipe,
    private formBuilder: UntypedFormBuilder,
    private walletService: WalletService,
    private modalService: BsModalService,
    private loaderService: LoaderService,
    private paymentService: PaymentService,
    private router: Router,
    private store: Store,
    private notificationService: NotificationService,
    private sharedService: SharedService
  ) {
    this.loaderService.setLoading(true);
    this.breadCrumbItems = [{ label: 'Wallet' }];
     this.walletForm = this.formBuilder.group({
       amount: [
         '',
         [
           Validators.required,
           Validators.pattern(this.regexp),
         ],
       ],
     });

    this.autopayForm = this.formBuilder.group({
      isautopay: [false],
      RecurringAmount: [''],
      modeofPayment: [null],
      autoPayRechargeLimit: [],
    });
   
  }
  prifileValidations = Validations;
  ngOnInit(): void {
    this.notificationService.emitNotificationUpdate();
    this.loaderService.setLoading(true);
    const currentUserString = localStorage.getItem('currentUser');
    this.currentUserData = JSON.parse(currentUserString ?? '');
    if (this.currentUserData.currentUserRoleDetails !== null) {
      this.useremail = this.currentUserData.currentUserRoleDetails.email;
      this.userId = this.currentUserData.currentUserRoleDetails.userId;
      this.userName = this.currentUserData.currentUserRoleDetails.userName;
      this.userPhone = this.currentUserData.currentUserRoleDetails.phone;
      /* this.isAutoPayForRecharge =
        this.currentUserData.currentUserRoleDetails?.isAutoPayForRecharge; */
    }
    if (this.currentUserData.project !== null) {
      this.projectId = this.currentUserData.project.id;
    }
    this.autopayForm.get('isautopay')?.valueChanges.subscribe((value) => {
      if (value == true) {
        this.autopayForm
          .get('RecurringAmount')
          ?.setValidators([
            Validators.required,
            Validators.min(this.min_amount),
            Validators.max(this.max_amount),
            Validators.pattern(this.regexp),
          ]);
        this.autopayForm
          .get('autoPayRechargeLimit')
          ?.setValidators([
            Validators.required,
            Validators.min(this.min_amount),
            Validators.max(this.max_amount),
            Validators.pattern(this.regexp),
          ]);

        this.autopayForm
          .get('modeofPayment')
          ?.setValidators([Validators.required]);
        this.autopayForm.get('RecurringAmount')?.updateValueAndValidity();
        this.autopayForm.get('RecurringAmount')?.updateValueAndValidity();
        this.autopayForm.get('autoPayRechargeLimit')?.updateValueAndValidity();
      } else {
        this.autopayForm.get('RecurringAmount')?.clearValidators();
        this.autopayForm.get('RecurringAmount')?.updateValueAndValidity();
        this.autopayForm.get('modeofPayment')?.clearValidators();
        this.autopayForm.get('modeofPayment')?.updateValueAndValidity();
        this.autopayForm.get('autoPayRechargeLimit')?.clearValidators();
        this.autopayForm.get('autoPayRechargeLimit')?.updateValueAndValidity();
      }
    });

    this.walletService.getwalletHistory(this.userId, this.projectId).subscribe({
      next: (res) => {
        if (res && res.statusCode === 200) {
          this.walletHistoryList = res.data;
          this.max_amount = this.walletHistoryList?.maxRechargeAmount;
          this.min_amount = this.walletHistoryList?.minRechargeAmount;
          this.isAutoPayForRecharge =
            this.walletHistoryList?.isAutoPayForRecharge;
          this.isLowBalanceAlertNotification =
            this.walletHistoryList?.isLowBalanceAlertNotification;

          const minValue =
            this.min_amount && this.min_amount > 0 ? this.min_amount : 1;
          let filterAmount = this.amountTempArray.filter(
            (data: any) =>
              this.walletHistoryList?.maxRechargeAmount >= data.amount
          );
          this.flatNos =
            this.walletHistoryList?.residentialUnits?.length > 0
              ? this.walletHistoryList.residentialUnits
                  .map((item: any) => item.flatNo)
                  .join(', ')
              : '';
          //console.log(this.flatNos);
          // console.log(this.flatNos);
          /* this.walletForm = this.formBuilder.group({
            amount: [
              '',
              [
                Validators.required,
                Validators.pattern(this.regexp),
                // this.noZeroValidator(),
                Validators.min(this.min_amount),
                Validators.max(this.max_amount),
              ],
            ],
          }); */
          this.walletForm.get('amount')?.setValidators([
            Validators.required,
            Validators.pattern(this.regexp),
            // this.noZeroValidator(),
            Validators.min(this.min_amount),
            Validators.max(this.max_amount),
          ]);
          this.amountValues = filterAmount;
           console.log(this.min_amount)

          this.loaderService.setLoading(false);
        }
      },
      error: (err) => {
        console.log(err);
        this.loaderService.setLoading(false);

        // Check if backend returned an error.message
        const errorMsg =
          err.error?.message || 'Something went wrong. Please try again later.';

        this.sharedService.showMessageDialog(
          errorMsg,
          '',
          SweetAlertIcon.ERROR
        );
      },
    });

    /*  this.store.dispatch(
      getwalletHistorylist({
        consumerId: this.userId,
        projectId: this.projectId,
      })
    ); */
  }
  get walletFormConntrols() {
    return this.walletForm.controls;
  }
  get autoPayControls() {
    return this.autopayForm.controls;
  }

  paymentAlertSucess(data: any) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-primary ms-2',
        popup: 'custom-popup',
      },
      buttonsStyling: false,
    });
    swalWithBootstrapButtons
      .fire({
        allowOutsideClick: false,
        //title: 'your wallet recharge is successfull',
        icon: 'success',
        text: `Success`,
        html: `
           <p>Your wallet recharge is successful!</p>
            <p>Name:</p>
           <p>Your wallet recharge is successful!</p>
           <p>Payment Id:!</p>
            <i id="download-icon" class="fas fa-download" style="font-size: 24px; cursor: pointer;"></i>
                  `,
        // iconHtml: '<i class="fas fa-download"></i>', // Include the download icon
        confirmButtonText: 'OK',
        showCancelButton: false,
      })
      .then((result) => {
        console.log(result, 'result');
        if (result.value) {
        }
      });

    const popup = Swal.getPopup();
    if (popup) {
      const downloadIcon = popup.querySelector('#download-icon');
      if (downloadIcon) {
        downloadIcon.addEventListener('click', () => {
          console.log('Download icon clicked');
          this.handleDownload(); // Call your download handler
        });
      }
    }
  }

  rechargeOperation(request: any) {
    // normal recharge
    this.paymentService.createpOrderId(request).subscribe(
      (response: any) => {
        const options = {
          key: AppConfigData.Razorpay_KeyId, // Replace with your Razorpay Key ID
          amount: request.amount * 100, // Amount in paise
          currency: 'INR',
          name: 'Ripple',
          description: ' Wallet Recharge ',
          // order_id: 'OZf8qRyQDdzyOH',
          order_id: response.data.orderId, // This is a sample Order ID. Pass the `id` obtained in the previous step
          handler: (response: any) => {
            // console.log(response, 'payment sucess response');
            // this.paymentAlertSucess();
            //this.sharedService.showMessageDialog('Success', 'Payment successful!', SweetAlertIcon.SUCCESS);
            this.walletForm.reset();

            this.loaderService.setLoading(true);
            this.OnPaymentSuccess(response);
            this.submitted = false;
            //alert(response.razorpay_payment_id);
            // alert(response.razorpay_order_id);
            // alert(response.razorpay_signature);
          },
          prefill: {
            name: this.userName,
            // email: '',
            contact: this.userPhone,
          },
          notes: {
            address: '',
            isAutopPay: 0,
            IsRecharge: 1,
            IsBill: 0,
            isRecurring: 0,

            // convenience_charge: '0',
          },
          config: {
            display: {
              /*  blocks: {
               convenience_charge: {
                 name: "Convenience Charge",
                 amount: 0 // Ensure convenience charge is 0
               }
             }, */
              hide: [
                { method: 'emi' },
                // { key: "convenience_charge" } // Hide convenience charge
              ],
            },
          },
          theme: {
            color: '#54bbf3',
          },
          modal: {
            escape: false,
            ondismiss: () => {
              console.log('orignal payment cancelled');
              this.OnPaymentFailure(response.data.orderId);
              this.loaderService.setLoading(false);
              this.sharedService.showMessageDialog(
                'Failure',
                'payment cancelled',
                SweetAlertIcon.ERROR
              );
            },
          },
          /*  const successCallback = (paymentid: any) => {
           console.log(paymentid);
         },
   
         const failureCallback = (paymentid: any) => {
           console.log(paymentid);
         } */
        };

        const rzp1 = new Razorpay(options);
        rzp1.open();
      },
      (error) => {
        console.log(error);

        const errorMsg =
          error?.error?.message || 'Something went wrong. Please try again.';

        this.sharedService.showMessageDialog(
          '',
          errorMsg,
          SweetAlertIcon.ERROR
        );

        this.loaderService.setLoading(false);
      }
    );
  }
  autoPayCheckBoxChange(event: any) {
    const target = event.target as HTMLInputElement;
    const isChecked = target?.checked ?? false;
    this.isAutoPayForRecharge = isChecked;
    console.log('Checkbox value:', isChecked);
    let text = isChecked
      ? 'Auto Pay Enabled'
      : ' To disable Auto Pay, please confirm your action ';
    if (!isChecked) {
      this.sharedService
        .showConfirmMessageDialog(
          'Are you sure?', // Title
          text, // Message
          SweetAlertIcon.WARNING // Icon type (can be 'warning', 'error', 'success', etc.)
        )
        .then((res) => {
          if (res.isConfirmed == true) {
            console.log(res.isConfirmed);
            let request = {
              ConsumerId: this.userId,
              //Type: 'recharge',
            };

            this.paymentService.disableAutoPay(request).subscribe({
              next: (res) => {
                console.log(res);
                if (res.statusCode == 200) {
                  this.sharedService.showMessageDialog(
                    '',
                    res.message,
                    SweetAlertIcon.SUCCESS
                  );
                  //this.autoPayRecharge();
                }
              },
              error: (err) => {
                console.log(err);
              },
            });
          } else {
            console.log(res.isConfirmed);
            this.isAutoPayForRecharge = !isChecked;
            target.checked = !isChecked;
          }
        });
    }
  }
  autoPayRecharge(request: any) {
    this.modelRef_1.hide();
    this.paymentService.setAutoPayOrdeId(request).subscribe({
      next: (response) => {
        this.loaderService.setLoading(false);
        const options = {
          key: AppConfigData.Razorpay_KeyId, // Replace with your Razorpay Key ID
          amount: request.RechargeAmount * 100, // Amount in paise
          currency: 'INR',
          name: 'Ripple',
          customer_id: response.data.CustomerId,
          recurring: '1',
          description: ' Wallet Recharge ',
          // order_id: 'OZf8qRyQDdzyOH',
          order_id: response.data.orderId,
          // This is a sample Order ID. Pass the `id` obtained in the previous step
          handler: (response: any) => {
            console.log(response, 'payment sucess response');
            // this.paymentAlertSucess();
            //this.sharedService.showMessageDialog('Success', 'Payment successful!', SweetAlertIcon.SUCCESS);
            this.walletForm.reset();

            this.loaderService.setLoading(true);
            this.OnPaymentSuccess(response);
            /*   setTimeout(() => {
              this.OnPaymentSuccess(response, response.data.orderId);
            }, 2000); */

            this.submitted = false;
            //alert(response.razorpay_payment_id);
            // alert(response.razorpay_order_id);
            // alert(response.razorpay_signature);
          },
          prefill: {
            name: this.userName,
            // email: '',
            contact: this.userPhone,
          },
          notes: {
            IsRecharge: 1,
            IsBill: 0,
            isAutopPay: 1,
            isRecurring: 0,

            // convenience_charge: '0',
          },
          config: {
            display: {
              /*  blocks: {
               convenience_charge: {
                 name: "Convenience Charge",
                 amount: 0 // Ensure convenience charge is 0
               }
             }, */
              hide: [
                { method: 'emi' },
                // { key: "convenience_charge" } // Hide convenience charge
              ],
            },
          },
          theme: {
            color: '#54bbf3',
          },
          modal: {
            escape: false,
            ondismiss: () => {
              console.log('orignal payment cancelled');
              this.OnPaymentFailure(response.data.orderId);
              this.loaderService.setLoading(false);
              this.sharedService.showMessageDialog(
                'Failure',
                'payment cancelled',
                SweetAlertIcon.ERROR
              );
            },
          },
          /*  const successCallback = (paymentid: any) => {
           console.log(paymentid);
         },
   
         const failureCallback = (paymentid: any) => {
           console.log(paymentid);
         } */
        };
        const rzp1 = new Razorpay(options);
        rzp1.open();
      },
      error: (error) => {
        console.log(error);

        const errorMsg =
          error?.error?.message || 'Something went wrong. Please try again.';

        this.sharedService.showMessageDialog(
          '',
          errorMsg,
          SweetAlertIcon.ERROR
        );

        this.loaderService.setLoading(false);
      },
    });
  }
  rechargeByAutoPay(AutoPay: any) {
    this.submitted = true;
    this.autosubmitted = false;
    if (this.walletForm.valid) {
      //if (this.walletFormConntrols['amount'].value != '') {
      this.modelRef_1 = this.modalService.show(AutoPay, {
        class: 'modal-dialog-centered',
        backdrop: 'static', //
      });
    }
  }

  async setAutoPayRecharge() {
    this.loaderService.setLoading(true);
    this.autosubmitted = true;
    let amount = this.walletForm.get('amount')?.value;
    let autoPayRechargeLimit = this.autopayForm.get(
      'autoPayRechargeLimit'
    )?.value;
    let recurringAmount = this.autopayForm.get('RecurringAmount')?.value;

    console.log(this.autopayForm.get('modeofPayment')?.value);
    if (this.autopayForm.invalid) {
      this.loaderService.setLoading(false);
      return;
    } else {
      let request = {
        RecurringAmount: parseInt(recurringAmount),
        ConsumerId: this.userId,
        RechargeAmount: amount,
        IsEnableAutoPay: this.autopayForm.get('isautopay')?.value,
        Mode: this.autopayForm.get('modeofPayment')?.value,
        isWebApp: true,
        ProjectId: this.projectId,
        AutoPayRechargeLimit: parseInt(autoPayRechargeLimit),
      };
      console.log(request);
      await this.autoPayRecharge(request);
    }
  }
  async payNow() {
    // this.modelRef_1.hide();
    this.loaderService.setLoading(true);
    this.submitted = true;
    let amount = this.walletForm.get('amount')?.value;
    let currentBalance = this.walletHistoryList?.currentBalance;
    // currentBalance = -1000
    if (this.walletForm.invalid) {
      this.loaderService.setLoading(false);
      return;
    } else {
      let request = {
        amount: amount,
        ConsumerId: this.userId,
        ProjectId: this.projectId,
        isWebApp: true,
      };
      if (currentBalance < 0) {
        // Ensure the recharge amount is greater than or equal to the absolute value of the negative balance
        if (amount && amount >= Math.abs(currentBalance)) {
          // Proceed with the recharge operation
          // Add your logic here for recharge
          await this.rechargeOperation(request);
        } else {
          let amount = Math.abs(this.walletHistoryList?.currentBalance);
          // Handle the case where the recharge amount is too small
          // You might want to show an error or validation message
          //Recharge denied. You must recharge an amount greater than  ${rechargeController.walletDetails.currentBalance.abs()}
          this.sharedService.showMessageDialog(
            'Failure',
            `Recharge denied. You must recharge an amount greater than ${amount}`,
            SweetAlertIcon.ERROR
          );
          this.loaderService.setLoading(false);
          console.log(
            'Recharge amount must be greater than or equal to the negative balance.'
          );
        }
      } else {
        // Handle the case where the balance is positive or zero
        // Add your logic for positive balance
        this.rechargeOperation(request);
      }
    }
  }

  handleDownload() {
    // Your download logic here
    console.log('Download action triggered');
  }
  config: any = {
    backdrop: true,
    ignoreBackdropClick: true,
  };
  OnPaymentSuccess(payment: any) {
    let request = {
      consumerId: this.userId,
      projectId: this.projectId,
      paymentId: payment.razorpay_payment_id,
      orderId: payment.razorpay_order_id,
      //signature: payment.razorpay_signature
    };
    // Make the initial API call
    const makePaymentApiCall = (retry: boolean = false) => {
      this.paymentService.getPaymentDetails(request).subscribe({
        next: (response: any) => {
          if (response.data && response.statusCode == 200) {
            if (response.data?.rechargeStatus.toLowerCase() == 'success') {
              let paymentData = { ...response.data };
              paymentData['paymentId'] = payment.razorpay_payment_id;
              paymentData['name'] = response.data.consumer;
              this.loaderService.setLoading(false);
              this.paymentlaertModal = this.modalService.show(
                RpAlertsComponent,
                {
                  initialState: { paymentData },
                  ...this.config,
                }
              );
              this.walletHistoryList = {
                ...this.walletHistoryList,
                lastRechargeAmount: response.data.lastRechargeAmount,
              };
              this.walletHistoryList = {
                ...this.walletHistoryList,
                lastRechargeDate: response.data.lastRechargeDate,
              };
              this.walletHistoryList = {
                ...this.walletHistoryList,
                currentBalance: response.data.currentBalance,
              };
            } else {
              console.log('Payment failed on first attempt.');
              this.walletHistoryList = {
                ...this.walletHistoryList,
                lastRechargeAmount: response.data.lastRechargeAmount,
              };
              this.walletHistoryList = {
                ...this.walletHistoryList,
                lastRechargeDate: response.data.lastRechargeDate,
              };
              this.walletHistoryList = {
                ...this.walletHistoryList,
                currentBalance: response.data.currentBalance,
              };
              // If first attempt failed, retry once after 5 seconds
              if (!retry) {
                console.log('Retrying payment...');
                setTimeout(() => {
                  makePaymentApiCall(true); // Retry API call
                }, 5000);
              } else {
                // After retry, still failed, show the payment failed message
                this.loaderService.setLoading(false);
                this.sharedService.showMessageDialog(
                  'Payment Sucess',
                  'Were processing your payment. This may take a little longer than usual. Please wait for 30 minutes and come back to the Recharge History ! ',
                  SweetAlertIcon.SUCCESS
                );
                // console.log("Payment failed after retry. No further attempts.");
              }
            }
          }
        },
        error: (error) => {
          this.sharedService.showMessageDialog(
            error.error.message,
            this.ServiceError.Error,
            SweetAlertIcon.ERROR
          );
          console.log(error);
          this.loaderService.setLoading(false);
        },
      });
    };
    // Call the payment API for the first time
    makePaymentApiCall();
  }

  OnPaymentFailure(orderId: any) {
    let request = {
      OrderId: orderId,
    };
    this.paymentService
      .paymentWalletFailure(request)
      .subscribe((response: any) => {});
  }
  setAmount(amount: any) {
    console.log(amount);
    this.walletForm.patchValue({ amount: amount });
    console.log(this.walletForm.get('amount')?.value);
  }
  onInputChange(event: any): void {
    const input = event.target as HTMLInputElement;
    const cleaned = input.value.replace(/[^0-9.]/g, '');

    if (input.value !== cleaned) {
      input.value = cleaned; // Update the visible input directly
    }

    // Let Angular's form control handle the update automatically
  }
  onInputChange2(event: any) {
    let newValue = event.target.value.replace(/[^0-9.]/g, '');
    // If you want to limit decimal places to two, you can uncomment the line below
    // newValue = this.limitDecimalPlaces(newValue, 2);
    this.walletForm.patchValue({ amount: newValue }, { emitEvent: false });
  }
  autopaychekbox(event: any) {
    console.log(event.target.checked);
  }
  onCheckboxChange(event: any) {
    console.log(event.target.checked);
    this.isLowBalanceAlertNotification = event.target.checked;
    let confirmMsg =
      this.isLowBalanceAlertNotification == true
        ? 'Do you want to enable low balance notifications and receive alerts when your wallet balance is low? '
        : 'Are you sure you want to disable low balance notifications? You will stop receiving alerts about your wallet balance';

    this.sharedService
      .showConfirmMessageDialog(
        'Are you sure?', // Title
        confirmMsg, // Message
        SweetAlertIcon.WARNING // Icon type (can be 'warning', 'error', 'success', etc.)
      )
      .then((res) => {
        let request = {
          isLowBalanceAlert: event.target.checked,
          ConsumerId: this.userId,
          ProjectId: this.projectId,
        };

        let sucessMsg =
          this.isLowBalanceAlertNotification == true
            ? 'You have enabled low balance notifications. You will now receive alerts when your wallet balance falls below the set threshold '
            : 'You have disabled low balance notifications. You will no longer receive alerts when your wallet balance is low';
        console.log(res.isConfirmed);
        if (res.isConfirmed == true) {
          this.loaderService.setLoading(true);
          this.walletService.lowBalanceNotificatonConfirm(request).subscribe({
            next: (res) => {
              if (res.statusCode == 200) {
                //  console.log('Emitting notification update')
                this.sharedService.showMessageDialog(
                  'Success',
                  sucessMsg,
                  SweetAlertIcon.SUCCESS
                );
                this.notificationService.emitNotificationUpdate();

                this.loaderService.setLoading(false);
              }
              // console.log(res)
            },
            error: (err) => {
              this.loaderService.setLoading(false);
              console.log(err);
            },
          });
        }
      });
  }
  bootstrap: any;
  showSuccessToast() {
    console.log('dgsjadsa');
    const toastEl = document.getElementById('successToast');
    if (toastEl) {
      const toast = new this.bootstrap.Toast(toastEl);
      toast.show();
    }
  }

  /* noZeroValidator() {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (value !== null && value !== undefined && Number(value) === 0) {
        return { noZero: true };
      }
      return null;
    };
  } */
}
